DialogSelectCtrl.$inject = ['$log', '$scope', '$http', '$q'];
export default function DialogSelectCtrl($log, $scope, $http, $q) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.items = null;
    vm.cargando = {
        datos: true,
        submit: false
    };

    vm.formDeshabilitado = true;
    vm.modoEdicion = false;
    vm.reparadores = null;

    cargarDatos();

    function cargarDatos() {
        vm.model.promesaDatos.then(function (datos) {
            vm.items = datos;
            vm.formDeshabilitado = false;
            vm.cargando.datos = false;
        });
    }

    vm.submit = function (item) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        vm.model.callbackSubmit(item).then(function () {
            vm.dialogHandler.close(item);
        }, function (err) {
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        });
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }

}